<template>
  <div>
    <div class="footer" v-if="isPC">
      <div class="footer-main w f-b">
        <div style="width: 60%" class="f-b">
          <div class="footer-main-box">
            <h6>{{ $t('Home.Components.BlackFooter.CATEGORIES') }}</h6>
            <p><a href="/product-list">{{ $t('Home.Components.BlackFooter.Products') }}</a></p>
            <p><a href="/dropshipping">{{ $t('Home.Components.BlackFooter.Dropshipping') }}</a></p>
            <p><a href="/service">{{ $t('Home.Components.BlackFooter.Customization') }}</a></p>
            <p><a rel="nofollow" href="https://affiliate.kakaclo.com/promote" target="_blank">{{ $t('Home.Components.BlackFooter.KakaCloAffiliate') }} </a></p>
          </div>
          <div class="footer-main-box">
            <h6>{{ $t('Home.Components.BlackFooter.RESOURCES') }}</h6>
            <p><a href="/attr">{{ $t('Home.Components.BlackFooter.ProductAttributes') }}</a></p>
            <p><a rel="nofollow" href="/privacy-policy">{{ $t('Home.Components.BlackFooter.PrivacyPolicy') }}</a></p>
            <p><a rel="nofollow" href="/terms-conditions">{{ $t('Home.Components.BlackFooter.TermsConditions') }}</a></p>
            <p><a rel="nofollow" href="/return-refund">{{ $t('Home.Components.BlackFooter.ReturnRefund') }}</a></p>
            <p><a rel="nofollow" href="/shipping">{{ $t('Home.Components.BlackFooter.ShippingDelivery') }}</a></p>
            <p><a rel="nofollow" href="/payment-method">{{ $t('Home.Components.BlackFooter.PaymentMethod') }}</a></p>
            <!-- <p><a href="/ip-right">IP Right</a></p> -->
          </div>
          <div class="footer-main-box">
            <h6>{{ $t('Home.Components.BlackFooter.ABOUTUS') }}</h6>
            <p><a rel="nofollow" href="/about-us">{{ $t('Home.Components.BlackFooter.Company') }}</a></p>
            <!-- <p><a href="https://kakacloblog.webflow.io/" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p> -->
            <!-- <p><a href="/blog" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p> -->
            <p><a href="https://www.kakaclo.com/wp-blog" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p>
            <p><a rel="nofollow" href="/help-center">{{ $t('Home.Components.BlackFooter.HelpCenter') }}</a></p>
            <p><a rel="nofollow" href="/contact-us">{{ $t('Home.Components.BlackFooter.ContactUs') }}</a></p>
            <!-- <p><a href="/aboutus">About Us</a></p> -->
          </div>
        </div>
        <div class="footer-main-box">
          <a href="/"><img style="width: 180px; display: inline-block; padding-bottom: 10px" src="@/assets/img/homePage/baidilogo.png" /></a>
          <p>{{ $t('Home.Components.BlackFooter.Email') }}: info@KakaClo.com</p>
          <p>{{ $t('Home.Components.BlackFooter.Phone') }}: +1 626 866 2112</p>
          <!-- <p>Address: 19H Maxgrand plaza,No.3 Tai Yau Strect,San Po Kong, Kowloon,Hong Kong</p> -->
          <p class="associate-box">
            <a href="https://www.facebook.com/KakaClo-Dropshipping-112237164586153" target="_blank"><img src="@/assets/img/homePage/facebook 1.png" alt="" lazy /></a>
            <a href="https://www.instagram.com/KakaClodropshipping/" target="_blank"><img src="@/assets/img/homePage/instagram 1.png" alt="" lazy /></a>
            <a href="https://www.youtube.com/channel/UCEnAXbQRPJcK7vyakzYxX-g/featured" target="_blank"><img src="@/assets/img/homePage/youtube.png" alt="" lazy /></a>
            <a href="https://twitter.com/DKakaClo" target="_blank"><img src="@/assets/img/homePage/twitter 1.png" alt="" lazy /></a>
            <el-popover placement="top" trigger="hover" content="">
              <p style="font-size: 20px; font-weight: 600; text-align: center; color: #121e26">{{ $t('Home.Components.BlackFooter.KakaCloSupport') }}</p>
              <p style="font-size: 14px; text-align: center">{{ $t('Home.Components.BlackFooter.WathsAppContact') }}</p>
              <oss-img src="https://img.kakaclo.com/web-img/whatsAPP.png" alt="" :width="90" :height="90" style="width: 100%"></oss-img>
              <a href="javascript:void(0);" slot="reference" target="_blank"><img src="@/assets/img/homePage/whatchAPP.png" alt="" lazy /></a>
            </el-popover>
          </p>
        </div>
      </div>
    </div>
    <div class="footer-s" v-else>
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item :title="$t('Home.Components.BlackFooter.CATEGORIES')" name="1">
          <p><a href="/product-list">{{ $t('Home.Components.BlackFooter.Products') }}</a></p>
          <p><a href="/dropshipping">{{ $t('Home.Components.BlackFooter.Dropshipping') }}</a></p>
          <p><a href="/service">{{ $t('Home.Components.BlackFooter.Customization') }}</a></p>
          <!-- <p><a href="https://affiliate.kakaclo.com/promote" target="_blank">{{ $t('Home.Components.BlackFooter.KakaCloAffiliate') }} </a></p> -->
        </el-collapse-item>
        <el-collapse-item :title="$t('Home.Components.BlackFooter.RESOURCES')" name="2">
          <p><a href="/attr">{{ $t('Home.Components.BlackFooter.ProductAttributes') }}</a></p>
          <p><a rel="nofollow" href="/privacy-policy">{{ $t('Home.Components.BlackFooter.PrivacyPolicy') }}</a></p>
          <p><a rel="nofollow" href="/terms-conditions">{{ $t('Home.Components.BlackFooter.TermsConditions') }}</a></p>
          <p><a rel="nofollow" href="/return-refund">{{ $t('Home.Components.BlackFooter.ReturnRefund') }}</a></p>
          <p><a rel="nofollow" href="/shipping">{{ $t('Home.Components.BlackFooter.ShippingDelivery') }}</a></p>
          <p><a rel="nofollow" href="/payment-method">{{ $t('Home.Components.BlackFooter.PaymentMethod') }}</a></p>
          <!-- <p><a href="/ip-right">IP Right</a></p> -->
        </el-collapse-item>
        <el-collapse-item :title="$t('Home.Components.BlackFooter.ABOUTUS')" name="3">
          <p><a rel="nofollow" href="/about-us">{{ $t('Home.Components.BlackFooter.Company') }}</a></p>
          <!-- <p><a href="https://kakacloblog.webflow.io/" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p> -->
          <!-- <p><a href="/blog" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p> -->
          <p><a href="https://www.kakaclo.com/wp-blog" target="_blank">{{ $t('Home.Components.BlackFooter.Blog') }}</a></p>
          <p><a rel="nofollow" href="/help-center">{{ $t('Home.Components.BlackFooter.HelpCenter') }}</a></p>
          <p><a rel="nofollow" href="/contact-us">{{ $t('Home.Components.BlackFooter.ContactUs') }}</a></p>
          <!-- <p><a href="/aboutus">About Us</a></p> -->
        </el-collapse-item>
      </el-collapse>
      <p style="text-align: center; margin: 35px 0 12px" class="f-c-c"><span>Email: info@KakaClo.com</span></p>
      <p class="associate-box f-c-c">
        <!-- <a href="https://www.facebook.com/KakaClo-Dropshipping-112237164586153" target="_blank"><img src="@/assets/img/homePage/facebook_b.svg" alt="" lazy /></a>
        <a href="https://www.instagram.com/KakaClodropshipping/" target="_blank"><img src="@/assets/img/homePage/ins_b.svg" alt="" lazy /></a>
        <a href="https://www.youtube.com/channel/UCEnAXbQRPJcK7vyakzYxX-g/featured" target="_blank"><img src="@/assets/img/homePage/youtube_b.svg" alt="" lazy /></a>
        <a href="https://twitter.com/DKakaClo" target="_blank"><img src="@/assets/img/homePage/twitter_b.svg" alt="" lazy /></a> -->

        <a href="javascript:;"><img src="@/assets/img/homePage/facebook 1.png" alt="" lazy /></a>
        <a href="javascript:;"><img src="@/assets/img/homePage/instagram 1.png" alt="" lazy /></a>
        <a href="javascript:;"><img src="@/assets/img/homePage/youtube.png" alt="" lazy /></a>
        <a href="javascript:;"><img src="@/assets/img/homePage/twitter 1.png" alt="" lazy /></a>

        <el-popover placement="top" trigger="click" content="">
          <p style="font-size: 20px; font-weight: 600; text-align: center; color: #121e26">{{ $t('Home.Components.BlackFooter.KakaCloSupport') }}</p>
          <p style="font-size: 14px; text-align: center">{{ $t('Home.Components.BlackFooter.WathsAppContact') }}</p>
          <!-- <oss-img :src="item.headImg" :width="12" :height="12" style="border-radius:50%"></oss-img> -->
          <oss-img src="https://img.kakaclo.com/web-img/whatsAPP.png" alt="" :width="90" :height="90" style="width: 100%"></oss-img>
          <!-- <a href="javascript:void(0);" slot="reference" target="_blank"><img src="@/assets/img/homePage/WhatsApp_b.svg" alt="" lazy /></a> -->
          <a href="javascript:;" slot="reference"><img src="@/assets/img/homePage/whatchAPP.png" alt="" lazy /></a>
        </el-popover>
      </p>
    </div>
    <div class="copyright-box" v-if="'/login' !== $route.path && '/register' !== $route.path">
      <!-- <div class="copyright">
        <oss-img src="https://img.kakaclo.com/home-img/%E5%BA%95%E9%83%A8%E6%94%AF%E4%BB%98%E6%96%B9%E5%BC%8F.png" alt="" :width="141" :height="16"></oss-img>
        <div>Copyright ©2024 All Rights Reserved By KakaClo</div>
        <a v-if="isPC" href="https://beian.miit.gov.cn" style="color:#2b3444" target="_blank">粤ICP备2022088924号-1</a>
        <a v-else href="https://beian.miit.gov.cn" style="color:#fff" target="_blank">粤ICP备2022088924号-1</a>
      </div> -->
      <div class="copyright f-c-c fw-w">
        <div class="f-c-c fd-c left">
          <div>Copyright ©2024 All Rights Reserved By KakaClo</div>
          <!-- <a v-if="isPC" href="https://beian.miit.gov.cn" style="color:#fff" target="_blank">粤ICP备2022088924号-1</a>
          <a v-else href="https://beian.miit.gov.cn" style="color:#fff" target="_blank">粤ICP备2022088924号-1</a> -->
        </div>
        <oss-img src="https://img.kakaclo.com/web-img/payment.png" alt="" :width="140" :height="12"></oss-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: []
    }
  },
  methods: {
    handleChange(val) {
      this.activeNames = val
    }
  }
}
</script>
<style lang="scss">
.w {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
.display {
  display: none;
}
.footer {
  // font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif' !important;
  width: 100%;
  background: #124537;
  padding-top: 60px;
}
.footer-main {
  width: 100%;
  padding-bottom: 60px;
  color: #fff;
  .footer-main-box {
    width: 25%;
  }
  h6 {
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    padding-bottom: 16px;
  }
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    padding-bottom: 8px;
    a {
      display: inline-block;
      font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
      font-weight: 400;
      color: #fff;
      font-size: 14px;
      line-height: 21px;
      text-decoration: none;
    }
  }
}
.associate-box {
  padding-top: 6px;
  a {
    color: #fff;
    margin: 0 5px;
    img {
      width: 22px;
    }
  }
}
.copyright-box {
  background: #124537;;
}
.copyright {
  // line-height: 80px;
  padding-bottom: 35px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: #fff;
  img {
    margin-bottom: 15px;
  }
  div {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    padding-bottom: 10px;
  }
}

.footer-s {
  background: #124537;
  // display: none;
  color: #fff;
  a {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    text-decoration: none;
  }
}
.footer-img {
  width: 280px;
  display: inline-block;
}
/deep/.el-collapse-item__header {
  height: 65px;
  padding: 0 20px;
  font-size: 16px;
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial', 'Sans-serif';
  font-weight: 400;
  background-color: #124537;
  color: #fff;
}
/deep/.el-collapse-item__content {
  padding: 0 20px 10px;
  font-size: 16px;
  background-color: #124537;
  a {
    color: #fff;
    font-size: 12px;
    line-height: 18px;
  }
}
.address-info {
  width: 415px;
  padding-bottom: 10px;
}
.address-icon {
  margin-right: 5px;
  margin-top: 5px;
}
.add-info {
  .add-title {
    font-size: 16px;
    color: #121e26;
    line-height: 32px;
    font-weight: 500;
  }
  .add-sub-title {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 1600px) {
  .w {
    width: 92%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 750px) {
  .footer {
    display: none;
  }
  .copyright-box {
    .copyright {
      font-size: 14px;
      padding-bottom: 20px;
    }
  }
  .footer-s {
    display: block;
  }
  .copyright {
    .left {
      width: 100%;
      margin-right: 0;
    }
  }
}
</style>
